import { render, staticRenderFns } from "./ContainerInfoPage.vue?vue&type=template&id=584604c1&scoped=true&"
import script from "./ContainerInfoPage.vue?vue&type=script&lang=js&"
export * from "./ContainerInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./ContainerInfoPage.vue?vue&type=style&index=0&id=584604c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584604c1",
  null
  
)

export default component.exports